import {
  Banner,
  BannerVariant,
  BannerStatus,
  BannerLeftAccessoryType,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";

interface Props {
  oauthErrorKey: string;
}

export const OAuthFailureMessage: React.FC<Props> = ({ oauthErrorKey }) => (
  <Banner
    variant={BannerVariant.Light}
    leftAccessory={{
      type: BannerLeftAccessoryType.Status,
      status: BannerStatus.Warning,
    }}
    title={<Trans>Unexpected error during sign in</Trans>}
  >
    {oauthErrorKey}
  </Banner>
);
